import script from "./RecordingRecovery.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordingRecovery.vue?vue&type=script&setup=true&lang=ts"

import "./RecordingRecovery.vue?vue&type=style&index=0&id=ff0920a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff0920a4"]])

export default __exports__